/* import __COLOCATED_TEMPLATE__ from './tin.hbs'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from '@ember/object';
import Component from '@ember/component';
import { SocialSecurityNumberFormatter, TextField } from 'field-kit';
let SSN = (_class = class SSN extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "onValueChange", () => {});
    _defineProperty(this, "initialValue", null);
  }
  async initializeFieldKit(marketInputTextElement) {
    const inputElement = await marketInputTextElement.getInputElement();
    const formatter = new SocialSecurityNumberFormatter();
    if (this.initialValue) {
      // eslint-disable-next-line require-atomic-updates
      marketInputTextElement.value = formatter.format(this.initialValue);
    }
    const fieldKit = new TextField(inputElement, formatter);
    const textDidChange = field => this.onValueChange(field.value());
    fieldKit.setDelegate({
      textDidChange
    });
  }
}, _applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype), _class);
export { SSN as default };